import { USER } from '../types';

export const searchInitialState = {
  name: '',
  showAgreement: true,
  lpHideDocSlicerTooltip: 0,
};

const userReducer = (state = searchInitialState, action) => {
  switch (action.type) {
    case USER.SET_NAME:
      let name = action.name;
      return {
        ...state,
        name,
      };

    case USER.ACCEPT_AGREEMENT:
      return {
        ...state,
        showAgreement: true,
      };

    case USER. SET_TOOLTIP:
      return {
        ...state,
        lpHideDocSlicerTooltip: action.value,
      };

    default:
      return state;
  }
};

export default userReducer;
